<template>
  <section>
    <ManageApiTokensTable
      v-if="canManageApiTokens && accountId"
      :accountId="accountId"
    />
    <ManageLegacyApiKey
      v-if="canViewLegacyApiKey"
      :collapsible="canManageApiTokens"
    />
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import { setTitle } from '@/utils/title';
import ManageApiTokensTable from '@/components/manage/api-token/ManageApiTokensTable.vue';
import ManageLegacyApiKey from '@/components/manage/api-token/ManageLegacyApiKey.vue';

export default {
  components: { ManageApiTokensTable, ManageLegacyApiKey },

  computed: {
    ...mapGetters({
      accountId: 'auth/accountId',
    }),
    canManageApiTokens() {
      return this.$can('manage', 'ApiTokens');
    },
    canViewLegacyApiKey() {
      return this.$can('view', 'LegacyApiKey');
    },
  },

  created() {
    setTitle('Manage API Access');
  },
};
</script>
